var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4884 13.4697C9.87934 13.4697 10.9941 14.6107 10.9941 16.0307V19.4397C10.9941 20.8497 9.87934 21.9997 8.4884 21.9997H5.1541C3.77303 21.9997 2.64844 20.8497 2.64844 19.4397V16.0307C2.64844 14.6107 3.77303 13.4697 5.1541 13.4697H8.4884ZM19.8725 13.4697C21.2536 13.4697 22.3781 14.6107 22.3781 16.0307V19.4397C22.3781 20.8497 21.2536 21.9997 19.8725 21.9997H16.5382C15.1472 21.9997 14.0325 20.8497 14.0325 19.4397V16.0307C14.0325 14.6107 15.1472 13.4697 16.5382 13.4697H19.8725ZM19.8725 1.99997C21.2536 1.99997 22.3781 3.14997 22.3781 4.56097V7.96997C22.3781 9.38997 21.2536 10.53 19.8725 10.53H16.5382C15.1472 10.53 14.0325 9.38997 14.0325 7.96997V4.56097C14.0325 3.14997 15.1472 1.99997 16.5382 1.99997H19.8725Z",
    fill: "url(#paint0_linear_8353_792)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9941 4.561C10.9941 3.15 9.8794 2 8.48846 2H5.15416C3.77309 2 2.6485 3.15 2.6485 4.561V7.97C2.6485 9.39 3.77309 10.53 5.15416 10.53H8.48846C9.8794 10.53 10.9941 9.39 10.9941 7.97V4.561Z",
    fill: "url(#paint1_linear_8353_792)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8353_792",
    x1: 12.5133,
    y1: 1.99997,
    x2: 12.5133,
    y2: 21.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8454EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8353_792",
    x1: 2.6485,
    y1: 6.265,
    x2: 10.9941,
    y2: 6.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F5A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.0bc07265ff16c3fee843f43879b459cf.svg";
export { ForwardRef as ReactComponent };